import React, { useState, useEffect } from 'react';
import {
  UserOutlined,
  LaptopOutlined,
  NotificationOutlined,
  TeamOutlined,
  PlusCircleOutlined,
  ShoppingCartOutlined,
  CheckCircleOutlined,
  FileAddOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  DownOutlined
} from '@ant-design/icons';

import {
  Breadcrumb,
  Layout,
  Menu,
  theme,
  Grid,
  Button,
  Avatar,
  Dropdown,
  Space,
  Drawer,
} from 'antd';
import { useNavigate, Link, Outlet } from "react-router-dom";
import axios from 'axios';

const { Header, Content, Sider } = Layout;
const { useBreakpoint } = Grid;

const PanelAdmin = () => {
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [usuario, setUsuario] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const screens = useBreakpoint();
useEffect(() => {
    const obtenerDatos = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get('https://elarigestion-production.up.railway.app/api/usuario', {
          headers: {
            Authorization: token,
          },
        });

        setUsuario(res.data);
      } catch (err) {
        setError('No se pudo cargar el perfil');
      } finally {
        setCargando(false);
      }
    };

    obtenerDatos();
  }, []);
  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/iniciar-sesion');
  };

  const items2 = [
    {
      key: 'sub1',
      icon: <UserOutlined />,
      label: 'Usuarios',
      children: [
        {
          key: 'usuarios registrados',
          icon: <TeamOutlined />,
          label: <Link to="usuarios">Usuarios registrados</Link>,
        },
        {
          key: 'registrar usuarios',
          icon: <PlusCircleOutlined />,
          label: <Link to="registrar-usuarios">Registrar usuario</Link>,
        },
      ],
    }
   
  ];

  const avatarMenu = {
    items: [
   /*    {
        key: '1',
        label: 'Mi perfil',
           onClick: () => navigate('/perfil'),
      }, */
      {
        key: '2',
        label: 'Cerrar sesión',
        onClick: handleLogout,
      },
    ],
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0 16px',
       
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
          {!screens.md && (
            <Button
              type="text"
              icon={<MenuUnfoldOutlined />}
              onClick={() => setDrawerVisible(true)}
              style={{ color: '#fff', marginRight: 16 }}
            />
          )}
        </div>
  <Dropdown menu={avatarMenu} placement="bottomRight" arrow>
          <Space style={{ color: '#fff', cursor: 'pointer' }}>
         <Avatar
           size="large"
          src={usuario?.avatar || null}
          style={{
            backgroundColor: usuario?.color_del_fondo || '#ffffff',
            color: '#000',
            fontWeight: 'bold',
            fontSize: 24,
          }}
        >
          {
            !usuario?.avatar && usuario?.nombre_completo
              ? usuario?.nombre_completo.charAt(0).toUpperCase()
              : null
          }
        </Avatar>
            <DownOutlined />
          </Space>
        </Dropdown>
  
      </Header>

      <Layout>
        {screens.md ? (
          <Sider
            width={200}
            collapsible
            collapsed={collapsed}
            onCollapse={(value) => setCollapsed(value)}
            style={{ background: colorBgContainer }}
          >
            <Menu
              mode="inline"
              defaultSelectedKeys={['1']}
              defaultOpenKeys={['sub1']}
              style={{ height: '100%', borderRight: 0 }}
              items={items2}
            />
          </Sider>
        ) : (
          <Drawer
            title="Menú"
            placement="left"
            onClose={() => setDrawerVisible(false)}
            open={drawerVisible}
            bodyStyle={{ padding: 0 }}
          >
            <Menu
              mode="inline"
              defaultSelectedKeys={['1']}
              defaultOpenKeys={['sub1']}
              style={{ height: '100%' }}
              items={items2}
              onClick={() => setDrawerVisible(false)}
            />
          </Drawer>
        )}

  <Layout style={{ padding: screens.md ? '0 24px 24px' : 0 }}>
  <Breadcrumb
    items={[{ title: '' }]}
    style={{ margin: screens.md ? '16px 0':   0 }}
  />
  <Content
    style={{
      padding: screens.md ? 24 : 0,
      margin: 0,
      background: colorBgContainer,
      borderRadius: borderRadiusLG,
    }}
  >
    <Outlet />
  </Content>
</Layout>

      </Layout>
    </Layout>
  );
};

export default PanelAdmin;
